const XML_ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&apos;' };

const escapeXml = (value) => value.replace(/[&<>"']/g, (ch) => XML_ESCAPES[ch]);

const toBase64 = (text) =>
  btoa(encodeURIComponent(text).replace(/%([0-9A-F]{2})/g, (_, hex) => String.fromCharCode(parseInt(hex, 16))));

export const firstInitial = (name) => {
  if (typeof name !== 'string') return '';
  const trimmed = name.trim();
  if (!trimmed) return '';
  return Array.from(trimmed)[0].toUpperCase();
};

export const initialsAvatar = (name, { size = 150, fallback = '' } = {}) => {
  const initial = escapeXml(firstInitial(name) || fallback);
  const half = size / 2;
  const fontSize = Math.round((size * 64) / 150);
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}"><circle cx="${half}" cy="${half}" r="${half}" fill="#333333"/><text x="50%" y="50%" font-family="Poppins, Arial, sans-serif" font-size="${fontSize}" font-weight="600" dy=".3em" fill="#84facb" text-anchor="middle">${initial}</text></svg>`;
  return `data:image/svg+xml;base64,${toBase64(svg)}`;
};

export default initialsAvatar;
